module.exports = __webpack_public_path__ + "static/media/default-image.36f8c7d2.JPG";